import { createFileRoute } from '@tanstack/react-router';
import { trpc } from '~/utils/trpc';

export const Route = createFileRoute('/$locale/health')({
  component: Health,
});

function Health() {
  const jobsQuery = trpc.jobs.list.useQuery({ limit: 5 });

  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-8">API Health Check</h1>
      
      <div className="p-6 bg-white rounded-lg shadow-md border-t-4 border-blue-500">
        <h2 className="text-xl font-semibold mb-4">tRPC Connection Status</h2>
        
        {jobsQuery.isLoading ? (
          <div className="flex items-center space-x-2 text-blue-600">
            <div className="animate-spin h-5 w-5 border-2 border-blue-600 border-t-transparent rounded-full"></div>
            <span>Connecting to API...</span>
          </div>
        ) : jobsQuery.isError ? (
          <div className="p-4 bg-red-50 border border-red-200 text-red-700 rounded-md">
            <p className="font-bold">Connection Failed</p>
            <p className="text-sm">{jobsQuery.error.message}</p>
          </div>
        ) : jobsQuery.data ? (
          <div className="space-y-4">
            <div className="p-4 bg-green-50 border border-green-200 text-green-700 rounded-md">
              <p className="font-bold">Successfully Connected!</p>
              <p className="text-sm">Retrieved {jobsQuery.data.jobs?.length || 0} jobs from the database via tRPC.</p>
            </div>

            <div className="mt-6">
              <h3 className="font-medium mb-2">Sample Jobs from API:</h3>
              <ul className="list-disc pl-5 space-y-1">
                {(jobsQuery.data.jobs || []).slice(0, 5).map((job) => (
                  <li key={job.id}>
                    <span className="font-semibold">{job.title}</span> at {job.company}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ) : (
          <div className="p-4 bg-yellow-50 border border-yellow-200 text-yellow-700 rounded-md">
            <p className="font-bold">No Data Available</p>
            <p className="text-sm">The API returned no data, but connection was successful.</p>
          </div>
        )}
      </div>
    </div>
  );
}
